/**
 * @generated SignedSource<<084b0424c94612936756397dca161ff2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutSidebarProjectPane_buyer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutSidebarProjectForm_buyer">;
  readonly " $fragmentType": "CheckoutSidebarProjectPane_buyer";
};
export type CheckoutSidebarProjectPane_buyer$key = {
  readonly " $data"?: CheckoutSidebarProjectPane_buyer$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutSidebarProjectPane_buyer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutSidebarProjectPane_buyer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutSidebarProjectForm_buyer"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "1e8fec26f4caa76e8c36e99294ee5b07";

export default node;
